import { keyframes } from 'styled-components'

export const FadeInWithVisibility = keyframes`
  from {
    opacity: 0;
    visibility: hidden;
  }
  50% { opacity: 1; }
  to {
    opacity: 1;
    visibility: visible;
  }
`
